import React, { useState } from 'react';

const RewindIcon = ({
  width = 32,
  height = 32,
  color = 'var(--ca-theme-palette-colors-controlButtonColor, #4B1C46)',
  hoverColor = 'var(--ca-theme-palette-colors-controlButtonColorHover, #29132e)',
  className = '',
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <circle cx="16" cy="16" r="16" fill={isHovered ? hoverColor : color} />
      <path
        d="M11.2227 15.5676L14.5979 12.7549C14.96 12.4543 15.5208 12.7057 15.5208 13.1874V18.8126C15.5208 19.2943 14.96 19.5474 14.5979 19.2451L11.2227 16.4325C10.9538 16.2074 10.9538 15.7926 11.2227 15.5676ZM15.7229 15.5676L19.0981 12.7549C19.4602 12.4543 20.021 12.7057 20.021 13.1874V18.8126C20.021 19.2943 19.4602 19.5474 19.0981 19.2451L15.7229 16.4325C15.454 16.2074 15.454 15.7926 15.7229 15.5676Z"
        fill="white"
      />
    </svg>
  );
};

export default RewindIcon;
